import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import Hero from './components/Hero';
import StatsBar from './components/StatsBar';
import CategorySection from './components/CategorySection';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

const pageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '爱漫画',
  url: 'https://aimanhua.com/',
  description: '爱漫画汇聚无删减韩国漫画，下拉式免费韩漫大全在线阅读便捷，优质韩漫作品持续上新。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://aimanhua.com/category?search={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="首页"
        description="爱漫画汇聚无删减韩国漫画，下拉式免费韩漫大全在线阅读便捷，优质韩漫作品持续上新，每日更新热门韩漫，满足您对韩漫的多样需求。"
        keywords="韩国漫画,无删减漫画,下拉式韩漫,免费韩漫大全,爱漫画,韩漫在线阅读"
        canonicalUrl="https://aimanhua.com/"
        schemaJson={pageSchema}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <CategorySection />
        <FeaturedComics />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}